import { toast } from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useCancelAppointment = (onSuccess) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error cancelling appointment");

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ id, cancellationReason }) => {
      const axiosInstance = createAxiosInstance();

      let url = `${tenantVal}/appointment/id/${id}/updatestatus/CANCELLED`;

      const response = await axiosInstance.post(url, {
        cancellationReason: cancellationReason,
      });

      return response.data;
    },
    onSuccess: () => {
      toast.success("Appointment cancelled successfully!");
      queryClient.invalidateQueries({ queryKey: ["appointments"] });
      queryClient.invalidateQueries({ queryKey: ["monthSlotCounts"] });
      onSuccess?.();
    },
    onError: handleNetworkError,
  });
};
